function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import { useAction } from 'hooks';
import { OtpResendBtn } from 'modules/Account/partials/OTP';
import { useOtpLockoutDuration } from 'modules/Account/hooks';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
const Actions = ({ onEditGuardianEmail })=>{
    const isCheckInProgress = useSelector(selectors.isCheckConfirmTermsOfServicesByGuardianProgress);
    const otpStatus = useSelector(selectors.otpStatus);
    const lockoutDuration = useOtpLockoutDuration(otpStatus);
    const verifyCodeCheck = useAction(actions.checkConfirmTermsOfServicesByGuardian);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row flex-column-reverse flex-sm-row w-100",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-6",
                        children: /*#__PURE__*/ _jsx(OtpResendBtn, {
                            lockoutDuration: lockoutDuration
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-12 col-sm-6",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            styleModifier: "primary",
                            className: "btn--block btn--filled",
                            labelMessage: messages.buttons.verifyCodeCheck,
                            isInProgress: isCheckInProgress,
                            isDisabled: false,
                            onClick: verifyCodeCheck
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "d-flex justify-content-center mt-6",
                children: /*#__PURE__*/ _jsx("a", {
                    "aria-hidden": "true",
                    onClick: onEditGuardianEmail,
                    className: "text--primary",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.editGuardianEmail))
                })
            })
        ]
    });
};
export default Actions;
